import { Avatar, type AvatarProps, styled } from '@mui/material';

type UserAvatarProps = AvatarProps & {
  name?: string;
  email?: string;
};

const UserAvatarColors = [
  '#F54D42',
  '#9664FE',
  '#FFCC24',
  '#02B78A',
  '#F9B6B0',
  '#69F6FF',
  '#A3A28A',
];

export const StyledAvatar = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== 'bgcolor',
})<{ bgcolor?: string }>(({ bgcolor }) => ({
  backgroundColor: bgcolor,
  width: 24,
  height: 24,
  fontSize: '.775rem',
  paddingTop: '2px',
}));

export const UserAvatar = (props: UserAvatarProps) => {
  const { name, email, ...rest } = props;

  const initial = getInitials(name, email);
  const value = getStringNumericalValue(`${name}${email}`);

  const colorIndex = value % UserAvatarColors.length;
  const avatarColor = UserAvatarColors[colorIndex];

  return (
    <StyledAvatar bgcolor={initial ? avatarColor : undefined} {...rest}>
      {initial}
    </StyledAvatar>
  );
};

const getStringNumericalValue = (inputString: string): number => {
  let numericalValue = 0;
  for (let i = 0; i < inputString.length; i++) {
    numericalValue += inputString.charCodeAt(i);
  }
  return numericalValue;
};

const getInitials = (name: string | undefined, email: string | undefined) => {
  if (!name && !email) return '';

  if (name === 'Admin' || email?.includes('@deleted.contact')) return '';

  const nameParts = name?.trim().split(' ') || [];
  const firstInitial = nameParts[0]?.charAt(0).toUpperCase() || '';
  const lastInitial = nameParts[1]?.charAt(0).toUpperCase() || '';
  const emailInitial = email?.charAt(0).toUpperCase() || '';

  if (firstInitial || lastInitial) {
    return `${firstInitial}${lastInitial}`;
  }

  return emailInitial;
};
